import { Icons } from '@agro-club/agroclub-shared'
import { refetchFunc } from 'modules/domain/common/hooks'
import { SellerSpec } from 'modules/domain/deal/types'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { EntityTitle } from '../styled'
import { AddSellerSpecification } from './SellerSpecificationModal/AddSellerSpecification'
import { SpecificationList } from './SpecificationList'

type Props = {
  specification: SellerSpec[]
  refetch: refetchFunc
}

export const SellerSpecification: FC<Props> = ({ specification, refetch }) => {
  const { t } = useTranslation('deal')
  const [newSpecificationModal, setNewSpecificationModal] = useState(false)

  const addButton = (
    <AButton id="addFile" color="approve" Icon={Icons.IconAdd} onClick={() => setNewSpecificationModal(true)}>
      {t('common:add')}
    </AButton>
  )

  return (
    <div>
      <EntityTitle>{t('accordion.dealFiles.seller_specification')}</EntityTitle>
      {!!specification.length ? <SpecificationList specifications={specification} refetch={refetch} /> : addButton}
      {newSpecificationModal && <AddSellerSpecification onSuccess={refetch} onClose={setNewSpecificationModal} />}
    </div>
  )
}
